import "../../sass/main.scss";
import {getPartnerID, validateEmail, validatePhone} from "../components/helpers";
import {bootPage} from "../app/boot-page";
import utils from "../utils/utils.js";
import {SwiperInit} from "../components/swiper";

export class Quiz {
    spinner = $('.load-wrapper');
    prev = '#prev';
    next = '#next';
    formSelector = 'form[data-quiz]';
    formButton = '[data-last-step]'
    hideClass = 'hide-opacity';
    activeClass = 'active';
    startQuizSelector = '[data-start-quiz]';
    input = 'input[data-radio-option][type="radio"]';

    constructor() {
        this.eventHandlers();
        this.swiper = SwiperInit();
    }

    eventHandlers() {
        //Methods
        $(document.body).on('block', this.block.bind(this));
        $(document.body).on('unblock', this.unblock.bind(this));
        $(document.body).on('slider_logic', this.sliderLogic.bind(this));
        $(document.body).on('next_slide', this.nextSlide.bind(this));

        //Events
        $(document.body).on('click', this.formButton, this.updateQuizAnswers.bind(this));
        $(document.body).on('submit', this.formSelector, this.formSubmitQuiz.bind(this));
        $(document.body).on('click', this.next, this.nextSlide.bind(this));
        $(document.body).on('click', this.prev, this.prevSlide.bind(this));
        $(document.body).on('click', this.startQuizSelector, this.triggerStartQuiz.bind(this));
        $(document.body).on('click', this.input, (e) => {
            setTimeout(() => this.nextSlide(), 500);
        });
    }

    block() {
        this.spinner.addClass('loading-posts');
    }

    unblock() {
        this.spinner.removeClass('loading-posts');
    }

    triggerStartQuiz() {
        $(this.next).trigger("click");
    }

    formSubmitQuiz(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        let data = $form.serializeArray();
        let valid = this.formSubmitQuizValidate($form);
        if (valid) this.formSubmitQuizAjax(data, false);
    }

    updateQuizAnswers(e) {
        e.preventDefault();
        let $form = $(this.formSelector);
        let data = $form.serializeArray();
        data.push({name: 'last_step', value: true});
        this.formSubmitQuizAjax(data, true);
    }

    formSubmitQuizValidate($form) {
        let obj = {};
        let error = 0;
        obj.email = $form.find("input[name='email']").val();
        obj.telephone = $form.find("input[name='telephone']").val();
        obj.first_name = $form.find("input[name='first_name']").val();
        obj.last_name = $form.find("input[name='last_name']").val();
        obj.accept = $form.find("input[name='accept-disclaimer']").is(':checked');
        $('.error-message').removeClass('active');
        $.each(obj, function (key, val) {

            if (val.length === 0) {
                utils.get_error_message(key);
                error++;
            }

            if (key === 'accept' && val !== true) {
                utils.get_error_message(key);
                error++;
            }

            if (key === 'email' && validateEmail(val) === false) {
                utils.get_error_message(key);
                error++;
            }

            if (key === 'telephone' && validatePhone(val) === false) {
                utils.get_error_message(key);
                error++;
            }

        });

        return (error === 0);
    }

    formSubmitQuizAjax(data, last_step) {
        $(document.body).trigger("block");
        data.push(
            {name: 'ng_pid', value: getPartnerID()},
            {name: 'update_answers', value: this.swiper.isEnd},
            {name: '_wpnonce', value: utils.get_nonce()},
            {name: 'action', value: 'wl_ajax_quiz'}
        );
        $.ajax({
            type: "POST",
            url: utils.get_ajax_url(),
            data: data,
            success: function (result) {
                $(document.body).trigger("unblock");
                if (result.type === 'quiz' || last_step) {
                    $('main').html(result.html);
                } else {
                    $('.swiper .swiper-slide.competition .flex-wrapper').html(result.html);
                    $(document.body).trigger("next_slide");
                }
            }
        });
    }

    sliderLogic(e, swiper) {
        $(swiper.el).find('.swiper-slide').hasClass('competition');
        let formExists = $(swiper.el).find('[type="submit"]').length;

        if (!swiper.isBeginning) {
            $('.bottom').addClass(this.activeClass);
        }

        if (swiper.isBeginning) {
            $(this.prev).addClass(this.hideClass);
            if (formExists) $(this.next).addClass(this.hideClass);
        } else if (swiper.isBeginning) {
            $(this.prev).addClass(this.hideClass);
            $(this.next).removeClass(this.hideClass);
        } else if (swiper.isEnd) {
            $(this.next).addClass(this.hideClass);
        } else if (!this.isCurrentSlideRadioChecked()) {
            $(this.next).addClass(this.hideClass);
            $(this.prev).removeClass(this.hideClass);
        } else {
            $(this.prev).removeClass(this.hideClass);
            $(this.next).removeClass(this.hideClass);
        }
    }

    isCurrentSlideRadioChecked() {
        let currentSlide = $(this.swiper.slides[this.swiper.activeIndex]);
        let radioButtons = currentSlide.find('input[type="radio"]');
        if (radioButtons.length === 0) return true; // No radio buttons on the slide
        return radioButtons.is(':checked');
    }

    nextSlide() {
        this.swiper.slideNext();
    }

    prevSlide() {
        this.swiper.slidePrev();
    }
}

bootPage(() => {
    new Quiz();
});
